export const urlDrivingInstructorSearch = '/api/search/drivingInstructor';
export const urlDrivingInstructor = '/api/driving-instructor';
export const urlDrivingLicense = '/api/driving-student/license';

export const urlUploadFile = '/api/file/upload/instructor-avatar';
export const urlDownloadFile = '/api/file/download/instructor-avatar';
